<p-listbox
  [options]="errorOptions"
></p-listbox>
